import { connect } from 'react-redux';
import React, { PropTypes } from 'react';
import { updateName } from '../actions/form';
import { getName, getErrors } from '../reducers/form';
import cx from 'classnames';

const mapStateToProps = state => ({
  name: getName(state),
  errors: getErrors(state),
});
const mapDispatchToProps = dispatch => ({
  updateName: event => dispatch(updateName(event.target.value)),
});

const CaseName = ({ name, updateName, errors }) => {
  const fieldClass = cx('field required', {
    error: errors.includes('name'),
  });

  return (
    <div className="ui segment">
      <div className="two fields">
        <div className={fieldClass}>
          <label>Nom du chantier</label>
          <input
            type="text"
            value={name}
            maxLength="256"
            required="true"
            onChange={updateName}
          />
        </div>
        <div className="field" />
      </div>
    </div>
  );
};

CaseName.propTypes = {
  name: PropTypes.string.isRequired,
  updateName: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(CaseName);



// WEBPACK FOOTER //
// ./src/modules/saas/pco/cases-creation/step1/components/CaseName.js